// LIBS
import { analytics_record } from "../../../../libs/amplify";
import { Google_Analytics_Event } from "../../../../libs/google-analytics";
// TYPES
import { PreviewConfig, PreviewCreativeData } from "../types";
import { User } from "../../../../types/user.context";

export function createPreviewLink(creative: PreviewCreativeData, user: User, configuration: PreviewConfig): string {
  Google_Analytics_Event({ name: "creative_preview", category: "ad_creative", action: "preview", label: creative.id });
  /**
   * The library table rows come straight from the creatives list query, which returns slides rather
   * than a flat mimeTypes list, so mimeTypes is absent there. Normalise both shapes so recording the
   * analytics event never breaks the preview itself. KT
   */
  const mimeTypes = creative.metadata.mimeTypes || (creative.metadata.slides || []).map((slide) => slide.media.mimeType);
  if (configuration.analytics.DISABLED === false && user.teamId !== "pi6j") {
    analytics_record({
      name: "preview",
      attributes: {
        eventType: "click",
        userId: `${user.id}`,
        userEmail: `${user.email}`,
        teamId: `${user.teamId}`,
        teamName: `${user.teamName}`,
        advertiserId: `${creative.advertiserId}`,
        advertiserName: `${creative.advertiserName}`,
        creativeId: `${creative.id}`,
        adName: `${creative.adName}`,
        brandName: `${creative.metadata.brandName}`,
        format: `${creative.metadata.format}`,
        assetType: `${mimeTypes.some((mimeType: string) => mimeType.includes("video")) ? "video" : "image"}`,
        previewURL: `https://${configuration.s3.BUCKET}.s3.${configuration.s3.REGION}.amazonaws.com/public/${user.teamId}/${creative.id}/index.min.html`,
      },
    });
  }
  const creativeWidth = `${configuration.adSlot.adSlotWidth}`;
  const creativeHeight = `${configuration.adSlot.adSlotHeight}`;
  const creativeDimensions = `${creativeWidth}x${creativeHeight}`;

  /**
   * HTL (20-07-23)
   * In development, we want to use an S3 object path to the index.min.html because this file has public:read ACL applied.
   * If we tried to use index.html, it would show a permission denied error.
   * In production, we want to send the user to the Preview site.
   * For staging, we mirror the production functionality with the staging preview URL.
   */
  if (configuration.environment === "development") {
    return `https://${configuration.s3.BUCKET}.s3.${configuration.s3.REGION}.amazonaws.com/public/${user.teamId}/${creative.id}/index.min.html`;
  }
  /**
   * JH (06-10-26)
   * The prod REACT_APP_PRODUCTION_PREVIEW_URL secret already ends in "/studio" (staging's doesn't), so
   * appending "/studio" gave ".../studio/studio/WxH/..." — which the preview site doesn't route, and it
   * fell back to its demo ad. Strip a trailing "/studio" so the link is right however the env is set.
   */
  const previewBase = (configuration.preview.URL || "").replace(/\/+$/, "").replace(/\/studio$/, "");
  if (configuration.environment === "production" || configuration.environment === "staging") {
    return `${previewBase}/studio/${creativeDimensions}/${user.teamId}/${creative.id}`;
  }
  return "";
}
